function onSwymLoadCallback(swat){
   window.swat = swat;
   setTimeout(function() { executeSwymCollectionsScript(swat); }, 500);
}

function executeSwymCollectionsScript(swat) {
    const currentLanguage = swat.retailerSettings.UI.Language ? swat.retailerSettings.UI.Language : 'english';
    const currentLocaleStrings = swat.retailerSettings.Strings
    const swymCollectionsModal = document.getElementById("swym-custom-collections-modal-background");
    const desktopModalTitle = document.getElementById("swym-custom-modal-title");
    const selectPreferenceText = document.getElementById("swym-custom-select-preference-text");
    const webpageBody = document.querySelector("html");
    const modalCloseButton = document.getElementById("swym-custom-modal-close");
    const mobileModalTitle = document.getElementById("swym-custom-mobile-title");
    const variantSelectionContainer = document.getElementById("swym-custom-variant-selector-container");
    const addToWishlistButton = document.getElementById("swym-custom-add-to-wishlist-button");
    const variantImage = document.getElementById("swym-custom-primary-image");
    const vendorTitle = document.getElementById("swym-custom-vendor-title");
    const productTitle = document.getElementById("swym-custom-product-title");
    const price = document.getElementById("swym-custom-variant-price");
    const variantTitle = document.getElementById("swym-custom-variant-title");
    const imgBlobContainer = document.getElementById("swym-custom-image-blob-container");
    const imageSliderContainer = document.getElementById("swym-custom-images-slide-container");
    const prevButton = document.getElementById("swym-custom-slide-arrow-prev");
    const nextButton = document.getElementById("swym-custom-slide-arrow-next");
    const successIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="30px" height="30px" fill="#D6CCC2"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>`;
    const errorIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 512 512" fill="#D6CCC2"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>`;

    let arrayOfSwymCollectionsButtons;
    let variantImagesArray;
    let productData;
    let productURL;
    let selectedVariant = {};
    let currentVariantId;
    let globalListArray = [];
    let globalProductsInListArray = [];
    let selectCallBackObj = [];

        const translationsObject = {
        'en': {
            addedToSingleList: "Wishlist",
            addedToMultipleLists: "Wishlists",
            selectPreferenceText: "Select Preferences",
            createListInputPlaceHolder: "Enter list name",
            addToWishlistTextNoListSelected: "Select List",
            singleWishlistButtonRemoveText: "Remove from Wishlist",
            // createListModalTitle: "Create New Wishlist",
            createListGuideText: "Wishlist Name",
            confirmNewListButtonText: "Save",
            cancelNewListButtonText:"Back To Overview",
            notificationAddText: "has been added to your Wishlist!",
            notificationRemoveText: "has been removed from your Wishlist",
            notificationUpdateText: "has been been updated in your Wishlists",
            listNameError: "List name must be at least 3 characters and less than 50 characters!",
            listNameNotUniqueError: " already exists! Please enter a unique name.",
            listLimitErrorMessage: "List limit of 10 Wishlists reached, please delete a wishlist to create newer wishlists.",
        },
        'de': {
            addedToSingleList: "Wunschliste",
            addedToMultipleLists: "Wunschlisten",
            selectPreferenceText: "Präferenzen auswählen",
            createListInputPlaceHolder: "Listenname eingeben",
            addToWishlistTextNoListSelected: "Liste auswählen",
            singleWishlistButtonRemoveText: "Aus der Wunschliste entfernen",
            // createListModalTitle: "Neue Wunschliste erstellen",
            createListGuideText: "Wunschlisten-Name",
            confirmNewListButtonText: "Speichern",
            cancelNewListButtonText:"Zurück zur Übersicht",
            notificationAddText: "wurde zu Ihrer Wunschliste hinzugefügt!",
            notificationRemoveText: "wurde aus Ihrer Wunschliste entfernt",
            notificationUpdateText: "wurde in Ihren Wunschlisten aktualisiert",
            listNameError: "Der Listenname muss mindestens 3 und weniger als 50 Zeichen enthalten!",
            listNameNotUniqueError: " existiert bereits! Bitte geben Sie einen eindeutigen Namen ein.",
            listLimitErrorMessage: "Das Limit von 10 Wunschlisten wurde erreicht. Bitte löschen Sie eine Wunschliste, um eine neue zu erstellen.",
        },
        'nl': {
            addedToSingleList: "Wishlist",
            addedToMultipleLists: "Wishlists",
            selectPreferenceText: "Voorkeuren selecteren",
            createListInputPlaceHolder: "Voer de lijstnaam in",
            addToWishlistTextNoListSelected: "Selecteer lijst",
            singleWishlistButtonRemoveText: "Verwijderen uit Wishlist",
            // createListModalTitle: "Nieuwe Wishlist maken",
            createListGuideText: "Naam van Wishlist",
            confirmNewListButtonText: "Opslaan",
            cancelNewListButtonText:"Terug Naar Owerzicht",
            notificationAddText: "is toegevoegd aan je Wishlist!",
            notificationRemoveText: "is verwijderd uit je Verlanglijst",
            notificationUpdateText: "is bijgewerkt in uw Verlanglijstjes",
            listNameError: "De lijstnaam moet minimaal 3 en minder dan 50 tekens bevatten!",
            listNameNotUniqueError: " bestaat al! Voer een unieke naam in.",
            listLimitErrorMessage: "De limiet van 10 verlanglijsten is bereikt. Verwijder een verlanglijst om een nieuwe te maken.",
        }
    };

    const shopifyLocale = Shopify.locale;
    const currentLanguageOption = translationsObject[shopifyLocale] ? translationsObject[shopifyLocale] : translationsObject['en'];
    const defaultWishlistTitle = currentLocaleStrings?.AddWishlistDefaultNewTitle;

    (function addTextToModal() {
        desktopModalTitle.textContent = currentLocaleStrings.AddWishlistPopupTitle;
        selectPreferenceText.textContent = currentLanguageOption.selectPreferenceText;
    })();

    function debounce_leading(func, timeout = 300) {
        let timer;
        return (...args) => {
            if (!timer) {
                func.apply(this, args);
            }
            clearTimeout(timer);
            timer = setTimeout(() => {
                timer = undefined;
            }, timeout);
        };
    }

    function customErrorHandling(error) {
        let html = `<div class="swymcs-notif-container">
            ${errorIcon}<span>${error}</span>
            </div>`;
        swat.ui.uiRef.showNotification({message: `${html}`});
    }

    function customSuccessHandling(success) {
        let html = `<div class="swymcs-notif-container">
            ${successIcon}<span>${success}</span>
            </div>`;
        swat.ui.uiRef.showNotification({message: `${html}`});
    }

    async function persistWishlistButtonsState() {
        return new Promise((resolve, reject) => {
            let onSuccess = function (lists) {
                globalListArray = lists;
                lists.forEach((list) => {
                    list.listcontents.forEach((product) => {
                        let productId = product.empi;
                        let buttonsToFill = document.querySelectorAll(`a#swym-collections[data-product-id="${productId}"]`);
                        buttonsToFill.forEach((buttonToFill)=>{
                            if (buttonToFill && !buttonToFill.classList.contains('swym-added')) {
                                SwymUtils.addClass(buttonToFill, "swym-added");
                            }
                        })
                    });
                });
                resolve();
            };

            let onError = function (error) {
                console.error("Error while fetching all Lists", error);
                reject(error);
            };

            swat.fetchLists({
                callbackFn: onSuccess,
                errorFn: onError,
            });
        });
    }

    async function handleRemoveFromWishlistButtonState(productId) {
        try {
            await persistWishlistButtonsState();
            const productIdExistsInSomeList = globalListArray.some((list) =>
                list.listcontents.some((product) => product.empi === productId)
            );

            if (!productIdExistsInSomeList) {
                const buttonsToUnFill = document.querySelectorAll(
                    `a#swym-collections[data-product-id="${productId}"]`
                );
                buttonsToUnFill.forEach((buttonToUnFill)=>{
                    if (buttonToUnFill) {
                        SwymUtils.removeClass(buttonToUnFill, "swym-added");
                    }
                })
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }

    function handleAddedToWishlistButtonState(productId) {
        let buttonsToFill = document.querySelectorAll(`a#swym-collections[data-product-id="${productId}"]`);
        buttonsToFill.forEach((buttonToFill)=>{
            if (buttonToFill && !buttonToFill.classList.contains('swym-added')) {
                SwymUtils.addClass(buttonToFill, "swym-added");
            }
        })
    }

    swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function (data) {
        let productId = data.detail.d.empi;
        handleRemoveFromWishlistButtonState(productId);
    });
    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function (data) {
        let productId = data.detail.d.empi;
        handleAddedToWishlistButtonState(productId);
    });

    function showZoomedView(e) {
        const zoomedView = document.createElement('div');
        const zoomedImage = new Image();
        SwymUtils.addClass(zoomedView, 'zoomed-image');
        zoomedImage.src = e.target.src;
        zoomedView.appendChild(zoomedImage);

        const closeButton = document.createElement('button');
        closeButton.setAttribute('aria-label', 'Close zoomed image');
        closeButton.classList.add('swym-zoomed-image-close-button', 'close-button');
        closeButton.innerHTML = '&times;';
        closeButton.addEventListener('click', () => {
            document.body.removeChild(zoomedView);
        });
        zoomedView.appendChild(closeButton);

        document.body.appendChild(zoomedView);

        zoomedView.addEventListener('click', (event) => {
            if (event.target === zoomedView) {
                document.body.removeChild(zoomedView);
            }
        });
    }

    function addImgBlobClickListener(event) {
        const imgBlobSrc = event.target.getAttribute("src");
        const allImgBlobs = document.querySelectorAll("#swym-custom-image-blob");
        variantImage.src = imgBlobSrc;

        allImgBlobs.forEach((imgBlob) => {
            if (imgBlob !== event.target) {
                imgBlob.classList.remove("selected");
            }
        });

        SwymUtils.toggleClass(event.target, "selected")
    }

    function addImageSliderEventListeners() {
        const slide = document.querySelector(".swym-custom-slider-image");
        nextButton.addEventListener("click", () => {
            const slideWidth = slide.clientWidth;
            imageSliderContainer.scrollLeft += slideWidth;
        });

        prevButton.addEventListener("click", () => {
            const slideWidth = slide.clientWidth;
            imageSliderContainer.scrollLeft -= slideWidth;
        });
    }

    function initializeSwipeableImageSlider() {
        let imageSlides = [];

        variantImagesArray.forEach((image, index) => {
            const imageSlide = document.createElement('img');
            imageSlide.src = image.src;
            imageSlide.ariaLabel = `product-image-${index}`;
            imageSlide.className = 'swym-custom-slider-image';
            imageSlide.width = '250';
            imageSlide.height = '250';
            imageSlide.addEventListener("click", showZoomedView);

            imageSlides.push(imageSlide);
            imageSliderContainer.appendChild(imageSlide);
        });

        addImageSliderEventListeners();
    }

    function addImageCarousel() {
        variantImagesArray = productData.product.images;
        initializeSwipeableImageSlider();
        const imgTags = variantImagesArray.map((image, index) => {
            const imgTag = document.createElement('img');
            imgTag.width = "24";
            imgTag.height = "24";
            imgTag.ariaLabel = `Product Secondary Image-${index}`;
            imgTag.id = `swym-custom-image-blob`;
            imgTag.src = image.src;

            imgTag.addEventListener("click", addImgBlobClickListener);

            return imgTag;
        });

        imgBlobContainer.innerHTML = '';
        imgBlobContainer.append(...imgTags);
    }

    function isVariantPresentInLists() {
        const variantInWishlist = globalProductsInListArray.some((product) => product.epi === currentVariantId);
        addToWishlistButton.classList.toggle("variant-in-wishlist", variantInWishlist);
        addToWishlistButton.textContent = variantInWishlist ? currentLanguageOption.singleWishlistButtonRemoveText : currentLocaleStrings.AddWishlistPopupCTASaveAdd;
    }

    function addWishlists() {
        swat.fetch((allWishlistedProducts) => {
            globalProductsInListArray = allWishlistedProducts;
            isVariantPresentInLists();
        }, (error) => customErrorHandling(error.description));

        toggleVariantData();
    }
    
    function toggleVariantData() {
        getSelectedVariant(selectCallBackObj);

        const currentProductTitle = productData.product.title;
        const currentProductVendor = productData.product.vendor;
        const alterNateVariantImages = productData.product.images;
        const currentVariantTitle = selectedVariant.title.replace(/\//g, "");
        const currentVariantPrice = window.Shopify.locale == 'de' ? window.swymFormatMoneyFunction(selectedVariant.price, window.Shopify.money_format, true) : window.swymFormatMoneyFunction(selectedVariant.price, window.Shopify.money_format);
        const imageId = selectedVariant.image_id;

        vendorTitle.innerHTML = "By: " + currentProductVendor;
        productTitle.innerHTML = currentProductTitle;
        variantTitle.innerHTML = currentVariantTitle;
        price.innerHTML = currentVariantPrice;

        for (let i = 0; i < alterNateVariantImages.length; i++) {
            if (alterNateVariantImages[i].id == imageId) {
                variantImage.setAttribute("src", alterNateVariantImages[i].src);
            } else {
                variantImage.setAttribute("src", productData.product.image.src);
            }
        }
    }

    function addProductData() {
        const product = productData.product;
        variantImage.src = product.image.src;
        vendorTitle.innerHTML = product.vendor;
        productTitle.innerHTML = product.title;
        mobileModalTitle.textContent = product.title;
        price.innerHTML = product.variants[0].price;

        addWishlists();
        addImageCarousel();
        renderVariantSelectors(productData);
    }

    function updateVariantInLists() {
        const product = {
            epi: currentVariantId,
            empi: productData.product.id,
            du: productURL
        };

        handleSingleWishlist(product);
        closeCollectionsModal();
    }


    function handleSingleWishlist(product) {
        if (!addToWishlistButton.classList.contains("variant-in-wishlist")) {
            swat.addToWishList(product, (response) => {
            }, (error) => { });
        } else {
            swat.removeFromWishList(product, (response) => {
                const updateMessage = `${productTitle.textContent} ${variantTitle.textContent} ${currentLanguageOption.notificationRemoveText}`;
                customSuccessHandling(updateMessage);
            }, (error) => { });
        }
    }

    function convertObjectToString(selectCallBackObj) {
        return Object.values(selectCallBackObj).join(" / ");
    }

    function getSelectedVariant(selectCallBackObj) {
        globalActionArray = [];
        const variants = productData.product.variants;
        let variantComboUnavailable = false;
        variants.forEach((variant) => {
            const filterTitle = convertObjectToString(selectCallBackObj);
            if (filterTitle == variant.title) {
                variantComboUnavailable = true;
                selectedVariant = variant;
                currentVariantId = variant.id;
            }
        });
        if (!variantComboUnavailable) {
            addToWishlistButton.setAttribute("disabled", true);
            addToWishlistButton.textContent = "Combination Unavailable";
        } else {
            addToWishlistButton.removeAttribute("disabled");
            addToWishlistButton.textContent = "Update List";
        }

        isVariantPresentInLists();
    }

    function handleRadioButtonClick(event) {
        const selectedValue = event.target.value;
        const optionIndex = event.currentTarget.getAttribute("optionIndex");

        selectCallBackObj = {
            ...selectCallBackObj,
            [optionIndex]: selectedValue,
        };

        const labels = event.currentTarget.parentNode.querySelectorAll(
            `label[for="${event.target.id}"]`
        );
        labels.forEach((label) => {
            label.classList.add("selected");
        });

        const unselectedRadios = event.currentTarget.parentNode.querySelectorAll(
            `input[type="radio"]:not([value="${selectedValue}"])`
        );
        unselectedRadios.forEach((radio) => {
            const labels = event.currentTarget.parentNode.querySelectorAll(
                `label[for="${radio.id}"]`
            );
            labels.forEach((label) => {
                label.classList.remove("selected");
            });
        });

        toggleVariantData();
    }

    function createRadioGroup(option, optionIndex) {
        const variantOptions = option.values
            .map((value) => {
                const isSelected = value == selectedVariant[`option${optionIndex + 1}`];
                return `<input style="display: none;" selected="${isSelected}" id="${option.name}-${value}" type="radio" name="${option.name}" optionIndex="${optionIndex}" value="${value}" aria-label="${option.name} ${value}"></input>
                        <label class="swym-filter-labels" for="${option.name}-${value}">${value}</label>`;
            })
            .join("");

        const radioGroup = document.createElement("div");
        radioGroup.setAttribute("class", `${option.name} swym-filter-option-name`);
        radioGroup.innerHTML = `<div id="swymOptionName" selected value="${option.name}">${option.name} : </div>
                                  <div class="swym-radio-buttons-container">${variantOptions}</div>`;

        const radioButtons = radioGroup.querySelectorAll(`[name="${option.name}"]`);
        for (let i = 0; i < radioButtons.length; i++) {
            radioButtons[i].addEventListener("click", function (event) {
                handleRadioButtonClick(event, productData);
            });
        }

        return radioGroup;
    }

    function renderVariantSelectors() {
        const optionsArray = productData.product.options;
        const variantSelectors = optionsArray.map((option, optionIndex) => {
            return createRadioGroup(option, optionIndex);
        });

        variantSelectionContainer.innerHTML = '';
        variantSelectors.forEach((variantSelector) => {
            variantSelectionContainer.append(variantSelector);
        });

        variantSelectors.forEach((variantSelector) => {
            const radioButtons = variantSelector.querySelectorAll(
                'input[type="radio"]'
            );
            if (radioButtons.length > 0) {
                radioButtons[0].click();
            }
        });
    }

    function closeCollectionsModal() {
        selectCallBackObj = {};
        swymCollectionsModal.classList.add("swym-hide-container");
        webpageBody.classList.remove("swym-modal-active");
        imageSliderContainer.innerHTML = '';
        variantSelectionContainer.innerHTML = '';
        imgBlobContainer.innerHTML = '';
        listIdContainer.innerHTML = '';
    }

    function openCollectionsModal() {
        addProductData(productData);

        swymCollectionsModal.classList.remove("swym-hide-container");
        variantImage.addEventListener("click", showZoomedView);
        webpageBody.classList.add("swym-modal-active");
        globalActionArray = [];

        window.addEventListener("click", (event) => {
            if (event.target === swymCollectionsModal) {
                closeCollectionsModal();
            }
        });
        imageSliderContainer.scrollLeft = 0;
    }


    function fetchProductDetails(event) {
        const rawUrl = event.currentTarget.attributes["data-product-url"].value;
        productURL = rawUrl.split("?")[0];
        const shopifyProductEndpoint = productURL + ".json";
        fetch(shopifyProductEndpoint)
            .then((res) => res.json())
            .then((productJson) => {
                productData = productJson;
                selectedVariant = productData.product.variants[0];
                openCollectionsModal();
            });
    }

    function addEventListeners() {
        arrayOfSwymCollectionsButtons = document.querySelectorAll("#swym-collections");
        if (arrayOfSwymCollectionsButtons){
            for (let i = 0; i < arrayOfSwymCollectionsButtons.length; i++) {
                if(!arrayOfSwymCollectionsButtons[i].classList.contains('swym-custom-loaded')){
                    arrayOfSwymCollectionsButtons[i].addEventListener("click", 
                        debounce_leading(fetchProductDetails, 500));
                    SwymUtils.addClass(arrayOfSwymCollectionsButtons[i], "swym-custom-loaded");
                }
            }
        }
        
        modalCloseButton.addEventListener("click", closeCollectionsModal);
        addToWishlistButton.addEventListener("click", debounce_leading(updateVariantInLists, 500));
        persistWishlistButtonsState();
    }

    addEventListeners();
    window.addEventListener('productcardVariants', (e) => {
        // console.log('productcardVariantsEvt from Shop the Look:', e);
        addEventListeners();
      });
      
    // window.swymFormatMoneyFunction = (cents, format = moneyFormat)=> {
    //     if (typeof cents === 'string') {
    //       cents = cents.replace('.', '');
    //     }
      
    //     let value = '';
    //     const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    //     const formatString = format || moneyFormat;
      
    //     switch(formatString.match(placeholderRegex)[1]) {
    //       case 'amount':
    //         value = window.swymFormatWithDelimiters(cents, 2);
    //         break;
    //       case 'amount_no_decimals':
    //         value = window.swymFormatWithDelimiters(cents, 0);
    //         break;
    //       case 'amount_with_comma_separator':
    //         value = window.swymFormatWithDelimiters(cents, 2, '.', ',');
    //         break;
    //       case 'amount_with_decimal_separator':
    //         value = window.swymFormatWithDelimiters(cents, 2, ',', '.');
    //         break;
    //     }
      
    //     return formatString.replace(placeholderRegex, value);
    // }
  
    window.swymFormatMoneyFunction = (cents, format = moneyFormat, currencyAfter = false) => {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
      
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;
      
        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = window.swymFormatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = window.swymFormatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = window.swymFormatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_with_decimal_separator':
            value = window.swymFormatWithDelimiters(cents, 2, ',', '.');
            break;
        }
      
        if (currencyAfter) {
          // Extract currency symbol (assuming it's not part of the placeholder)
          const parts = formatString.split(placeholderRegex);
          let currencySymbol = '';
          
          // Find which part has the currency symbol
          if (parts[0].trim()) {
            currencySymbol = parts[0].trim();
            return value + ' ' + currencySymbol;
          } else if (parts.length > 1 && parts[1].trim()) {
            currencySymbol = parts[1].trim();
            return value + ' ' + currencySymbol;
          }
        }
      
        // Default original behavior
        return formatString.replace(placeholderRegex, value);
      }

    window.swymFormatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (isNaN(number) || number == null) { return 0; }
    
        number = (number / 100.0).toFixed(precision);
    
        let parts = number.split('.');
        let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        let centsAmount = parts[1] ? (decimal + parts[1]) : '';
    
        return dollarsAmount + centsAmount;
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(onSwymLoadCallback);

